import { Box } from '@mui/material';

interface MiddleTruncatedProps {
    value: string;
    tail?: number;
}

export default function MiddleTruncated({
    value,
    tail = 8,
}: MiddleTruncatedProps) {
    const split = Math.max(value.length - tail, 0);
    return (
        <Box component="span" display="flex" minWidth={0} title={value}>
            <Box
                component="span"
                sx={{
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {value.slice(0, split)}
            </Box>
            <Box component="span" sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
                {value.slice(split)}
            </Box>
        </Box>
    );
}
